<template>
  <SList>
    <SListItem
      :disabled="disabled"
      data-cy="sdui-list-item"
      :title="$t('classbook.absences.user_absences.category')"
      right-action-icon="icon-chevron-right"
      :right-action-label="absenceTypeName"
      @click="$emit('click')"
    ></SListItem>
  </SList>
</template>

<script>
import constants from 'src/config/constants.ts'

export default {
  name: 'AbsenceCategoryDisplay',
  props: {
    types: {
      type: Object,
      default: () => ({}),
    },

    absence: {
      type: Object,
      default: () => ({}),
    },

    selectedType: {
      type: Object,
      default: null,
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    defaultTypeCategory: {
      type: String,
      default: constants.classbook.absences.types.STANDARD_TYPE_CATEGORY,
    },
  },

  data: () => ({}),
  computed: {
    absenceType() {
      const { types } = this.types

      if (!types) return
      if (this.selectedType) return this.selectedType
      if (this.absence.type_id) return types.find((el) => el.id === this.absence.type_id)

      return types.find((el) => el.category === this.defaultTypeCategory)
    },

    absenceTypeName() {
      return this.absenceType?.name || this.absence?.type?.name
    },
  },

  emits: ['click'],
}
</script>
